import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TypedDialog } from '@platform/dialog/dialog-v2.service';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { DialogBaseComponent } from '../dialog-base/dialog-base.component';

export interface ConfirmDialogData {
  titleTranslationKey: string;
  titleInterpolateParams?: object;
  textTranslationKey: string;
  textInterpolateParams?: object;
  btnOkTranslationKey?: string;
  btnCancelTranslationKey?: string;
}

export interface ConfirmDialogReturn {
  isConfirmed: boolean;
  isClosed?: boolean; // dialog was closed (by cross button)
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, DialogBaseComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements TypedDialog<ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogReturn> {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogReturn>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  get okKey() {
    return this.data.btnOkTranslationKey || 'shared.ok';
  }

  get cancelKey() {
    return this.data.btnCancelTranslationKey || 'shared.cancel';
  }

  get resultOnClose(): ConfirmDialogReturn {
    return { isConfirmed: false, isClosed: true };
  }

  confirm() {
    this.dialogRef.close({ isConfirmed: true });
  }

  cancel() {
    this.dialogRef.close({ isConfirmed: false });
  }
}
